import Alpine from 'alpinejs';
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';

// Components

import 'swiper/css';
import 'swiper/css/effect-fade';

Swiper.use([Autoplay, EffectFade, Navigation, Pagination]);

// Global
window.Alpine = Alpine;
window.Swiper = Swiper;

// Inits
Alpine.start();